import { render, staticRenderFns } from "./remak.vue?vue&type=template&id=135beeaf&scoped=true&"
import script from "./remak.vue?vue&type=script&lang=ts&"
export * from "./remak.vue?vue&type=script&lang=ts&"
import style0 from "./remak.vue?vue&type=style&index=0&id=135beeaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135beeaf",
  null
  
)

export default component.exports